// extracted by mini-css-extract-plugin
export default {"MainLayout":"mainLayout_MainLayout__G6frT","MainBody":"mainLayout_MainBody__mkDSI"};